export default {"src":"/_next/static/media/link-icon.8e001468.svg","height":18,"width":9,"blurWidth":0,"blurHeight":0};